<template>
  <section style="min-height: 400px;">
    <h2
      style="font-size: 200%;
  font-weight: 600;
  text-align: center;
  margin-bottom: 2%;"
    >
      蜜月專區管理
    </h2>
    <b-tabs
      v-model="activeTab"
      :animated="false"
      class="boarder-tabs"
      destroyOnHide
      multiline
      expanded
    >
      <b-tab-item :label="$t('attributes.top_banner')" :disabled="loading">
        <honey-moon-top-banner-list></honey-moon-top-banner-list>
      </b-tab-item>
      <b-tab-item
        :label="
          $t('attributes.area') +
            $t('attributes.and') +
            $t('attributes.offer') +
            $t('attributes.content')
        "
        :disabled="loading"
      >
        <honey-moon-area-list></honey-moon-area-list>
      </b-tab-item>
      <b-tab-item :label="$t('attributes.travel_group')" :disabled="loading">
        <honey-moon-travel-group-list></honey-moon-travel-group-list>
      </b-tab-item>
      <b-tab-item :label="$t('attributes.blog_share')" :disabled="loading">
        <honey-moon-blog-list></honey-moon-blog-list>
      </b-tab-item>
    </b-tabs>
  </section>
</template>

<script>
import HoneyMoonTopBannerList from '@/components/company/HoneyMoonTopBannerList'
import HoneyMoonAreaList from '@/components/company/HoneyMoonAreaList'
import HoneyMoonBlogList from '@/components/company/HoneyMoonBlogList'
import HoneyMoonTravelGroupList from '@/components/company/HoneyMoonTravelGroupList'

export default {
  name: 'HoneyMoons',
  components: {
    HoneyMoonTravelGroupList,
    HoneyMoonBlogList,
    HoneyMoonAreaList,
    HoneyMoonTopBannerList
  },
  data() {
    return {
      activeTab: 0,
      loading: false
    }
  }
}
</script>
